import { store } from 'store';

export const getToken = () => {
  const tokenFromRedux = store.getState()?.auth?.isAuthenticate?.access_token;
  const tokenFromStorage = localStorage.getItem('access_token');
  return tokenFromRedux || tokenFromStorage || '';
};
